import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  user,
  domain,
  boardId,
  publicId,
  placeholderId,
  name,
  type,
  dashboard_id: dashboardId,
}) => new Promise((resolve) => {
  const data = {
    object: 'chart',
    action: 'read',
  };

  if (boardId) {
    data.dashboard_id = boardId;
    data.user = user;
    data.domain = domain;
  }

  if (publicId) { data.public_id = publicId; }

  if (placeholderId) {
    data.placeholder_id = placeholderId;
    data.user = user;
    data.domain = domain;
  }

  if (dashboardId) { data.dashboard_id = dashboardId; }

  if (name) { data.name = name; }

  if (type) { data.type = type; }

  nsApi.get(data).then((res) => {
    if (res.length) {
      res.forEach((chart) => {
        // eslint-disable-next-line no-param-reassign
        chart.data_sources = chart.data_sources ? JSON.parse(chart.data_sources) : [];
        // eslint-disable-next-line no-param-reassign
        chart.properties = chart.properties ? JSON.parse(chart.properties) : [];
        if (chart.properties.length === 0) { // if we ended up with an empty array, make it an empty object
          // eslint-disable-next-line no-param-reassign
          chart.properties = {};
        }
      });
    }

    resolve(res);
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
